/*
  ALMAM - taburile de sub pagina de produs.

  Pana ruleaza scriptul asta, pagina arata toate panourile unul sub altul si nu
  arata deloc randul de taburi. Scriptul e cel care marcheaza radacina cu
  `almam-tabs--ready`, iar foaia de stil abia atunci aprinde taburile si ascunde
  panourile in plus. Ordinea asta e intentionata: daca ascunderea ar veni din
  CSS, un vizitator cu JS blocat - si motoarele de cautare - ar pierde tot
  continutul in afara de primul tab.

  Legatura buton <-> panou se face prin `aria-controls`, adica prin exact
  atributul de care are nevoie si un cititor de ecran. Nu exista o a doua
  evidenta care sa ajunga sa nu fie de acord cu prima.
*/

(function () {
  'use strict';

  var GATA = 'almamTabsGata';

  function panouri(radacina) {
    return Array.prototype.filter.call(
      radacina.querySelectorAll('[role="tabpanel"]'),
      function (panou) {
        // Doar panourile acestei sectiuni, nu si ale altei sectiuni cuibarite.
        return panou.closest('[data-almam-tabs]') === radacina;
      }
    );
  }

  function taburi(radacina) {
    return Array.prototype.filter.call(
      radacina.querySelectorAll('[role="tab"]'),
      function (tab) {
        return tab.closest('[data-almam-tabs]') === radacina;
      }
    );
  }

  function alege(radacina, tabAles, mutaFocus) {
    taburi(radacina).forEach(function (tab) {
      var esteAles = tab === tabAles;
      tab.setAttribute('aria-selected', esteAles ? 'true' : 'false');
      /* Doar tabul ales ramane in ordinea de tabulare. Asa `Tab` sare peste
         restul si duce direct in continut, iar intre taburi se umbla cu
         sagetile - cum se asteapta cine navigheaza de la tastatura. */
      tab.setAttribute('tabindex', esteAles ? '0' : '-1');

      var panou = document.getElementById(tab.getAttribute('aria-controls'));
      if (panou) panou.hidden = !esteAles;
    });

    if (mutaFocus && tabAles) tabAles.focus();

    /* Un widget randat intr-un panou ascuns se masoara la latime ZERO: aplicatia
       de recenzii isi calculeaza coloanele, graficele si caruselul pe ce vede in
       momentul incarcarii. Cand panoul se arata, dimensiunile lui reale abia
       atunci exista, iar widget-ul ramane desenat pe cele vechi.

       Semnalul standard prin care se cere unui widget sa se remasoare e chiar
       evenimentul de redimensionare a ferestrei; il asculta orice biblioteca
       serioasa. Se trimite dupa ce randul urmator de layout s-a asezat, altfel
       widget-ul ar citi tot dimensiunile vechi. */
    requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });
  }

  function laTasta(radacina) {
    return function (event) {
      var lista = taburi(radacina);
      var i = lista.indexOf(event.target);
      if (i === -1) return;

      var urmator = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        urmator = lista[(i + 1) % lista.length];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        urmator = lista[(i - 1 + lista.length) % lista.length];
      } else if (event.key === 'Home') {
        urmator = lista[0];
      } else if (event.key === 'End') {
        urmator = lista[lista.length - 1];
      }

      if (!urmator) return;
      event.preventDefault();
      alege(radacina, urmator, true);
    };
  }

  function porneste(radacina) {
    if (radacina.dataset[GATA]) return;

    var lista = taburi(radacina);
    var listaPanouri = panouri(radacina);

    /* Cu un singur panou nu exista nimic de comutat: randul de taburi ar fi
       decor. Sectiunea ramane in starea ei de baza, cu panoul si titlul lui. */
    if (lista.length < 2 || listaPanouri.length < 2) return;

    radacina.dataset[GATA] = '1';
    radacina.classList.add('almam-tabs--ready');

    lista.forEach(function (tab) {
      tab.addEventListener('click', function () {
        alege(radacina, tab, false);
      });
      tab.addEventListener('keydown', laTasta(radacina));
    });

    alege(radacina, lista[0], false);
    deschideDupaAdresa(radacina);
  }

  /* Deschide tabul care contine elementul cerut de adresa paginii.

     De ce e nevoie: aplicatiile de recenzii trimit legaturi catre widget-ul lor
     (`...#air-reviews`), iar un client venit dintr-un email ar ajunge pe pagina
     cu tabul inchis si ar crede ca recenzia lui a disparut. La fel pentru orice
     legatura din pagina care duce intr-un panou. */
  function elementDinAdresa(radacina, hash) {
    if (!hash || hash.length < 2) return null;
    try {
      return radacina.querySelector(hash);
    } catch (e) {
      // Un hash care nu e selector valid nu e o eroare, doar nu ne priveste.
      return null;
    }
  }

  function deschideCareContine(radacina, element) {
    if (!element) return null;
    var panou = element.closest('[role="tabpanel"]');
    if (!panou || panou.closest('[data-almam-tabs]') !== radacina) return null;

    var tab = radacina.querySelector('[aria-controls="' + panou.id + '"]');
    if (tab) alege(radacina, tab, false);
    return panou;
  }

  function deschideDupaAdresa(radacina) {
    deschideCareContine(radacina, elementDinAdresa(radacina, window.location.hash));
  }

  function init(zona) {
    (zona || document).querySelectorAll('[data-almam-tabs]').forEach(porneste);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* In editorul de teme sectiunea se re-randeaza la fiecare modificare: cea
     veche dispare cu tot cu ascultatorii ei, iar `DOMContentLoaded` nu se mai
     emite. Fara asta taburile ar parea moarte exact acolo unde se lucreaza la
     pagina. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  /* O legatura din pagina care duce intr-un panou inchis nu ar face nimic
     vizibil: browserul sare la un element ascuns. Se deschide intai tabul, apoi
     se coboara la element. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href^="#"]') : null;
    if (!link) return;

    var hash = link.getAttribute('href');
    if (!hash || hash.length < 2) return;

    document.querySelectorAll('[data-almam-tabs]').forEach(function (radacina) {
      var element = elementDinAdresa(radacina, hash);
      if (!element) return;
      if (deschideCareContine(radacina, element)) {
        event.preventDefault();
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('[data-almam-tabs]').forEach(deschideDupaAdresa);
  });

  /* Cand merchantul apasa un bloc in editor, tabul lui trebuie sa se deschida -
     altfel ar edita un text pe care nu-l vede. */
  document.addEventListener('shopify:block:select', function (event) {
    var bloc = event.target;
    var radacina = bloc.closest('[data-almam-tabs]');
    if (!radacina) return;

    var tab = bloc.getAttribute('role') === 'tab' ? bloc : bloc.querySelector('[role="tab"]');
    if (tab) alege(radacina, tab, false);
  });
})();
